import framebus from 'framebus'

/* eslint-disable no-unused-vars */

const getTarget = function(target) {
  return '*'
}

const eventBus = {
  publish: function(event, args, target, callback) {
    target = getTarget(target)
    return framebus.target(target).emit(event, args, callback)
  },
  emit: function(event, args, target, callback) {
    return this.publish(event, args, target, callback)
  },
  trigger: function(event, args, target, callback) {
    return this.publish(event, args, target, callback)
  },
  pub: function(event, args, target, callback) {
    return this.publish(event, args, target, callback)
  },
  subscribe: function(event, callback, target) {
    target = getTarget(target)
    return framebus.target(target).subscribe(event, callback)
  },
  sub: function(event, callback, target) {
    return this.subscribe(event, callback, target)
  },
  on: function(event, callback, target) {
    return this.subscribe(event, callback, target)
  },
  unsubscribe: function(event, callback, target) {
    target = getTarget(target)
    return framebus.target(target).unsubscribe(event, callback)
  },
  unsub: function(event, callback, target) {
    return this.unsubscribe(event, callback, target)
  },
  off: function(event, callback, target) {
    return this.unsubscribe(event, callback, target)
  }
}

export default eventBus
